import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faGoogle, 
  faFacebook
} from '@fortawesome/free-brands-svg-icons';
import { toast } from 'react-toastify';
import { socialAuthService } from '../services/socialAuthService';

interface SocialLoginButtonsProps {
  onGoogleLogin?: () => void;
  onFacebookLogin?: () => void;
  variant?: 'login' | 'signup';
  disabled?: boolean;
}

const SocialLoginButtons: React.FC<SocialLoginButtonsProps> = ({
  onGoogleLogin,
  onFacebookLogin,
  variant = 'login',
  disabled = false
}) => {
  const handleGoogleLogin = async () => {
    console.log(`DEBUG: handleGoogleLogin chamado com variant: ${variant}`);
    
    if (onGoogleLogin) {
      onGoogleLogin();
      return;
    }
    
    try {
      await socialAuthService.initiateSocialAuth('google', variant);
    } catch (error) {
      toast.error('Erro ao iniciar login com Google');
      console.error('Google login error:', error);
    }
  };

  const handleFacebookLogin = async () => {
    console.log(`DEBUG: handleFacebookLogin chamado com variant: ${variant}`);
    
    if (onFacebookLogin) {
      onFacebookLogin();
      return;
    }
    
    try {
      await socialAuthService.initiateSocialAuth('facebook', variant);
    } catch (error) {
      toast.error('Erro ao iniciar login com Facebook');
      console.error('Facebook login error:', error);
    }
  };

  return (
    <Box className="social-login-container">
      <Typography variant="body2" align="center" className="social-divider">
        ou {variant === 'login' ? 'entre' : 'cadastre-se'} com
      </Typography>
      
      <Box className="social-buttons">
        <Button
          variant="outlined"
          fullWidth
          size="large"
          onClick={handleGoogleLogin}
          disabled={disabled}
          className="social-button google-button"
          startIcon={<FontAwesomeIcon icon={faGoogle} />}
        >
          {variant === 'login' ? 'Entrar' : 'Cadastrar'} com Google
        </Button>

        <Button
          variant="outlined"
          fullWidth
          size="large"
          onClick={handleFacebookLogin}
          disabled={disabled}
          className="social-button facebook-button"
          startIcon={<FontAwesomeIcon icon={faFacebook} />}
        >
          {variant === 'login' ? 'Entrar' : 'Cadastrar'} com Facebook
        </Button>
      </Box>
    </Box>
  );
};

export default SocialLoginButtons;
